export const constants = {
    /** These should probably be human-readable. */
    sectionIds: {
        form: 'jaa-intohimosi',
        intohimotyoryhma: 'intohimotyoryhma',
        namifesti: 'muutoksen-menu',
        qa: 'kysymyksia-ja-vastauksia',
    },
};
